// ===========================================================================
// SUBMIT DELLA POPUP SCONTALO SUBITO
// ===========================================================================
$('#popup-privilege').on('click', '#submit-privilege', function () {

  // Cacho il campo per visualizzare gli eventuali errori
  const $errore = $('#popup-privilege .error-message');

  // Prendo gli elementi del pulsante e della form
  const $form = $('#popup-privilege form');
  const $pulsante = $('#submit-privilege');

  // Prendo le informazioni inserite dall'utente
  const nlemail = $('#EmailSpecialPrice').val();
  let nlnome = $('#NomeSpecialPrice').val();
  let nlcognome = $('#CognomeSpecialPrice').val();

  // Controllo se i valori esistono
  if (nlemail === undefined || nlemail === null || !nlemail.length) {
    $errore.text('ERRORE - IL CAMPO EMAIL E\' OBBLIGATORIO');
    return;
  }
  if (nlnome === undefined || nlnome === null || !nlnome.length) {
    $errore.text('ERRORE - IL CAMPO NOME E\' OBBLIGATORIO');
    return;
  }
  if (nlcognome === undefined || nlcognome === null || !nlcognome.length) {
    $errore.text('ERRORE - IL CAMPO COGNOME E\' OBBLIGATORIO');
    return;
  }

  // controllo se l'indirizzo email è formalmente valido
  const re = /.+@.+\..+/i;
  if (re.test(nlemail) === false) {
    $errore.text('ERRORE - INDIRIZZO EMAIL NON VALIDO');
    return;
  }

  // Rimuovo qualsiasi carattere non conforme (speciale) dal nome e dal cognome
  nlnome = nlnome.replace(/[-'`~!@#$%^&*()_|+=?;:'",.<>{}[]\\\/]/gi, '');
  nlcognome = nlcognome.replace(/[-'`~!@#$%^&*()_|+=?;:'",.<>{}[]\\\/]/gi, '');

  // Faccio l'encode dei caratteri speciali
  nlnome = encodeURIComponent(nlnome);
  nlcognome = encodeURIComponent(nlcognome);

  // Setto il cookie mail da utilizzare per il retargeting
  /* eslint-disable no-undef */
  // setRtMail(nlemail);

  // Avvio l'iscrizione alla newsletter / false nessun buono sconto
  submitNewsletter($form, $pulsante, nlemail, nlnome, nlcognome, false);
});


// ===========================================================================
// GESTIONE APERTURA DELLA POPUP
// ===========================================================================
// $('body').on('click', '.privilege-button', function () {
//   openPopup($('#popup-privilege'), overlay);
// });
